import { customizeValidator } from "@rjsf/validator-ajv8";

const allowedFileRegex = /^[^\\/\0]+(?:[\\/\w\-. ]+(?:\([^\0]*\))?)*(?:\.[a-zA-Z0-9]+)?$/;

export const customValidator = customizeValidator({
  customFormats: {
    rana_file: allowedFileRegex,
    rana_directory: allowedFileRegex,
    rana_dataset: allowedFileRegex,
  },
});
